module.exports = __webpack_public_path__ + "img/sbtech.d552bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/sbtech.png
// module id = Z1Sj
// module chunks = 38 43